import React from "react";
var __jsx = React.createElement;
import stl from "./TitleSection.module.css";
import SingleTitleStep from "./SingleTitleStep";
import { useTranslation } from "@i18n";
var TitleSection = function TitleSection(_ref) {
  var step = _ref.step;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.TitleSectionContainer
  }, /*#__PURE__*/React.createElement(SingleTitleStep, {
    currentStep: step === 1,
    isDone: step > 1,
    title: t("personal_information", {
      ns: "web_checkout_finance"
    })
  }), /*#__PURE__*/React.createElement(SingleTitleStep, {
    currentStep: step === 2,
    isDone: step > 2,
    title: t("work_information", {
      ns: "web_checkout_finance"
    })
  }), /*#__PURE__*/React.createElement(SingleTitleStep, {
    currentStep: step === 3,
    isDone: step > 3,
    title: t("validation_required_documents", {
      ns: "web_checkout_finance"
    })
  }));
};
export default TitleSection;